import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import isEqual from 'lodash/isEqual';
import {MetricAxis, MetricInfo, MetricParams} from '@store/@types/metric';
import {MenuGrow} from '@components/menu-grow/MenuGrow';
import {groupColors, groupLabels} from './NineBox.const';

interface NineBoxAxisOptionsProps {
  options: MetricInfo[];
  setAxisMetric: (val: {metricAxis: MetricAxis; metricParams: MetricParams}) => void;
  metricAxis: MetricAxis;
  metricParams: MetricParams;
}

/**
 * Handles select boxes to choose data shown on x and y axis
 */
export const NineBoxAxisOptions: React.FC<NineBoxAxisOptionsProps> = ({
  options,
  setAxisMetric,
  metricAxis,
  metricParams,
}) => {
  // This change triggers an API Call, so make sure it's worth it
  const onChange = value => {
    if (!isEqual(value, metricParams)) {
      setAxisMetric({
        metricAxis,
        metricParams: value,
      });
    }
  };

  const isVertical = metricAxis === MetricAxis.VERTICAL;
  const {centerFlex} = useStyles();

  return (
    <div className={centerFlex}>
      <MenuGrow
        value={metricParams}
        onChange={onChange}
        options={options}
        groupLabels={groupLabels}
        groupColors={groupColors}
        isEqual={(a, b) => a?.equals(b)}
        vertical={isVertical}
      />
    </div>
  );
};

const useStyles = makeStyles(theme => ({
  centerFlex: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
